import { c as _c } from "react/compiler-runtime";
import { useField } from 'formik';
import styled, { css } from 'styled-components';
import Button from '../../base/Button';
import Icon from '../../base/Icon';
import Text from '../../base/Text';
import TextInput from '../../Form/Fields/TextInput';
import { Div } from '../../helpers/StyledUtils';
const StyledInput = styled(TextInput)(({
  theme
}) => css`
    ${Text} {
      font-size: ${theme.pxToRem(theme.font_sizes.xs.font_size)};
      line-height: ${theme.pxToRem(theme.font_sizes.xs.line_height)};
    }
  `);
const NumberRangeFilter: React.FC<{
  name: string;
  title: string;
  min_label?: string;
  max_label?: string;
  delete_button?: JSX.Element;
  in_dropdown?: boolean;
  onBack?: () => void;
  onSubmit: () => void;
  onReset: () => void;
}> = t0 => {
  const $ = _c(30);
  const {
    name,
    title,
    min_label,
    max_label,
    in_dropdown,
    onBack
  } = t0;
  const t1 = `${name}.min`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      name: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [, t3] = useField(t2);
  const {
    error: error_min
  } = t3;
  const t4 = `${name}.max`;
  let t5;
  if ($[2] !== t4) {
    t5 = {
      name: t4
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const [, t6] = useField(t5);
  const {
    error: error_max
  } = t6;
  const has_error = error_min || error_max;
  let t7;
  if ($[4] !== has_error) {
    t7 = has_error ? <Text m={{
      t: 1,
      b: 0
    }} size="xs" as="p" danger={true}><Icon icon="info" left={1} />{has_error}</Text> : null;
    $[4] = has_error;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const error = t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      direction: "column",
      gap: 3
    };
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== in_dropdown || $[8] !== onBack || $[9] !== title) {
    t9 = in_dropdown ? <Div flex={{
      align: "center",
      gap: 3
    }}><Button outline={true} small={true} icon="arrow_back" onClick={onBack} /><Text semi={true}>{title}</Text></Div> : null;
    $[7] = in_dropdown;
    $[8] = onBack;
    $[9] = title;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      justify: "space-between"
    };
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      px: 122
    };
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = min_label || "Min";
  const t13 = `${name}.min`;
  let t14;
  if ($[13] !== t12 || $[14] !== t13) {
    t14 = <StyledInput m={0} w={t11} label={t12} name={t13} type="number" min={0} placeholder="-" max={10000} show_error={false} />;
    $[13] = t12;
    $[14] = t13;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Div m={{
      t: 6
    }} h={{
      px: 32
    }} flex={{
      align: "center",
      justify: "center"
    }}>–</Div>;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      px: 122
    };
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  const t17 = max_label || "Max";
  const t18 = `${name}.max`;
  let t19;
  if ($[18] !== t17 || $[19] !== t18) {
    t19 = <StyledInput m={0} w={t16} label={t17} name={t18} type="number" placeholder="-" min={0} max={10000} show_error={false} />;
    $[18] = t17;
    $[19] = t18;
    $[20] = t19;
  } else {
    t19 = $[20];
  }
  let t20;
  if ($[21] !== t14 || $[22] !== t19) {
    t20 = <Div flex={t10}>{t14}{t15}{t19}</Div>;
    $[21] = t14;
    $[22] = t19;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] !== error || $[25] !== t20) {
    t21 = <Div>{t20}{error}</Div>;
    $[24] = error;
    $[25] = t20;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== t21 || $[28] !== t9) {
    t22 = <Div><Div flex={t8} p={3}>{t9}{t21}</Div></Div>;
    $[27] = t21;
    $[28] = t9;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  return t22;
};
export default NumberRangeFilter;